<div class="mainContainer">
	<app-meeting-intro [$open]="this.showIntro"></app-meeting-intro>
	<div>
		<div class="map" id="map" [hidden]="step!==1"></div>
		<app-shared-view [(selectedPanorama)]="selectedPanorama" [(sitePanoramicHotspots)]="sitePanoramicHotspots"
						 [isOwner]="isOwner()" [(selectedMonument)]="selectedMonument" [(fileToShare)]="fileToShare"
						 [site]="selectedSite" [(monumentView)]="monumentView" [(isMonumentOpen)]="isMonumentOpen" [monumentClass]="'xl'">
		</app-shared-view>
		<div class="alertNotify" *ngIf="this.notifications.length > 0 && isOwner()">
			<ng-container *ngFor="let notification of notifications">
				<ngb-alert (close)="notification.close = true" *ngIf="!notification.close">{{notification.user.name}} raised hand</ngb-alert>
			</ng-container>
		</div>
		<div class="row">
			<div class="col-12">
				<div class="action-ribbon">
					<ul>
						<li ngbTooltip="Open the video chat window" container="body">
							<span class="left badge">0</span>
							<span class="right badge">1</span>
							<button (click)="openPanel('users')" [class.active]="panelsState.users">
								<fa-icon [icon]="['fas','users']"></fa-icon>
							</button>
						</li>
						<li ngbTooltip="Open the chat panel" container="body">
							<span class="right badge">1</span>
							<button (click)="openPanel('message')" [class.active]="panelsState.message">
								<fa-icon [icon]="['far','comment-dots']"></fa-icon>
							</button>
						</li>
						<li ngbTooltip="Open your personal folders and files" container="body">
							<button (click)="openPanel('files'); syncFolder();" [class.active]="panelsState.files">
								<fa-icon [icon]="['fas','folder']"></fa-icon>
							</button>
						</li>
						<li ngbTooltip="Open the CultureApp database" container="body">
							<button (click)="openPanel('cultureFiles')" [class.active]="panelsState.cultureFiles">
								<fa-icon [icon]="['fas','landmark']"></fa-icon>
							</button>
						</li>
						<li ngbTooltip="Return to the map" container="body">
							<button (click)="changeStep(1)">
								<fa-icon [icon]="['fas','globe-europe']"></fa-icon>
							</button>
						</li>
						<li ngbTooltip="View information about the Tour." container="body">
							<button (click)="openPanel('info')" [class.active]="panelsState.info">
								<fa-icon [icon]="['fas','info-circle']"></fa-icon>
							</button>
						</li>
						<li ngbTooltip="View information about the Tour." container="body">
							<button (click)="openHelp()">
								<fa-icon [icon]="['far','question-circle']"></fa-icon>
							</button>
						</li>
					</ul>
				</div>
				<div class="meetingSpotContainer users" [class.active]="panelsState.users">
					<div style="padding: 5px;">
						<app-online-indicator [size]="20" color="green" style="margin-right: 4px"></app-online-indicator>
						<span class="usersText" *ngIf="meeting">{{remoteCalls.length + 1}} of {{ordersUser.length + 1}} users online</span>
						<span class="usersText" *ngIf="!meeting">
							 Available users 1 <b>presentation mode</b>
							<br><br><em style="font-size: 0.9em;">When you will be in a meeting there will be camera spots of all visitors.</em>
						</span>
					</div>
					<div class="spotsContainer">
						<div class="row">
							<ng-container *ngIf="meeting">
								<div class="col-6" *ngFor="let user of ordersUser">
									<app-meeting-spot [spotName]="user.name"
													  [isOwner]="isOwner()"
													  [channelName]="this.channelName"
													  [callsActions]="remoteCallsActions[this.channelName + '_local_' + user.id]"
													  [connected]="isStreamConnected(this.channelName + '_local_' + user.id)"
													  [useId]="user.id"></app-meeting-spot>
								</div>
							</ng-container>
							<ng-container *ngIf="!meeting">
								<div class="col-6" *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
									<app-meeting-spot [spotName]="'Spot_'+i"
													  [isOwner]="false"
													  [channelName]="this.channelName"
													  [callsActions]="null"
													  [connected]="false"
													  [useId]="'Spot_'+i"></app-meeting-spot>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="guideView">
						<app-meeting-spot *ngIf="this.ownerId" [connected]="isStreamConnected(this.channelName + '_local_'+this.ownerId)"
										  [useId]="this.ownerId"
										  [channelName]="this.channelName"
										  [spotName]="'Tour-Guide: '+this.ownerName "></app-meeting-spot>
					</div>
				</div>
				<div class="meetingSpotContainer chat" [class.active]="panelsState.message">
					<div style="padding: 5px;">
						<app-online-indicator [size]="20" color="green" style="margin-right: 4px;"></app-online-indicator>
						<span class="usersText">Chat Room</span>
					</div>
					<div class="chatContainer">
						<div class="chatBox" #chatBox>
							<ng-container *ngFor="let message of receivedMessages">
								<div class="message-row" [ngClass]="{'me': message.name === userName}">
									<div class="message-text">
										{{message.text}}
									</div>
									<div class="message-name">{{message.name}}</div>
								</div>
							</ng-container>
						</div>
						<div class="inputContainer">
							<div class="textarea">
								<textarea placeholder="Type your message here" #textSend (keydown.enter)="sendMessage()"></textarea>
							</div>
							<div class="sendbutton">
								<button (click)="sendMessage()">SEND</button>
							</div>
						</div>
					</div>
				</div>
				<div class="actionContainer guide" *ngIf="step===2 && isOwner()">
					<ul>
						<li class="pointer">
							<button [class.on]="actionGuide === 'mouse'" (click)="selectGuideAction('mouse')">
								<fa-icon [icon]="['fas','mouse-pointer']"></fa-icon>
							</button>
						</li>
						<li class="spot">
							<button [class.on]="actionGuide === 'pin'" (click)="selectGuideAction('pin')">
								<fa-icon [icon]="['fas','map-pin']"></fa-icon>
							</button>
						</li>
						<li class="arrow">
							<button [class.on]="actionGuide === 'arrow'" (click)="selectGuideAction('arrow')">
								<fa-icon [icon]="['fas','arrow-down']"></fa-icon>
							</button>
						</li>
						<li class="circle">
							<button [class.on]="actionGuide === 'circle'" (click)="selectGuideAction('circle')">
								<fa-icon [icon]="['far','circle']"></fa-icon>
							</button>
						</li>
					</ul>
				</div>
				<div class="actionContainer bottom">
					<ul>
						<li class="share" *ngIf="isOwner()">
							<button ngbTooltip="Share the screen" (click)="shareScreen()">
								<fa-icon [icon]="['fas','share-square']"></fa-icon>
							</button>
						</li>
						<li class="raiseHand" *ngIf="!isOwner()">
							<button ngbTooltip="Raise hand to ask question" [class.on]="actions.hand" (click)="raiseHand()">
								<fa-icon [icon]="['fas','hand-paper']"></fa-icon>
							</button>
						</li>
						<li class="microphoneToggle" *ngIf="isOwner()">
							<button ngbTooltip="Mute/Unmute microphone" (click)="toggleMicrophone()">
								<div class="turnOfLine" *ngIf="!actions.microphone"></div>
								<fa-icon [icon]="['fas','microphone']"></fa-icon>
							</button>
						</li>
						<li class="cameraToggle">
							<button ngbTooltip="Turn on/off your camera" (click)="toggleCamera()">
								<div class="turnOfLine" *ngIf="!actions.video"></div>
								<fa-icon [icon]="['fas','video']"></fa-icon>
							</button>
						</li>
						<li class="turnOf" ngbTooltip="Leave meeting room">
							<button (click)="turnOfCall()">
								<fa-icon [icon]="['fas','phone']"></fa-icon>
							</button>
						</li>
					</ul>
				</div>
				<div class="guidePanelContainer cultureFiles" *ngIf="isOwner()" [class.closed]="!panelsState.cultureFiles">
					<div class="guideInner">
						<h3 class="text-center">Culture App Files</h3>
						<div class="monumentContainer">
							<input type="text" placeholder="Search a monument in culture app repository"
								   style="margin-bottom: 10px; width: 100%;  background: #dfdede; color: black;" />
							<div *ngIf="monuments$ | async as monumentDtos else loader" class="row">
								<div *ngFor="let monument of monumentDtos" class="col-6">
									<ng-container *ngTemplateOutlet="monumentBox;context:{monument:monument}"></ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="guidePanelContainer info" *ngIf="isOwner()" [class.closed]="!panelsState.info">
					<div class="guideInner">
						<h3 class="text-center">Last share info</h3>
						<div class="lastShareContainer">
							<div class="row info">
								<div class="col-4 guideData"><b>Panoramic: </b><br /> Natural</div>
								<div class="col-4 guideData"><b>Monument: </b><br /> Babius Monument</div>
								<div class="col-4 guideData"><b>Monument View: </b><br /> 3D view</div>
								<div class="col-4 guideData"><b>File: </b><br /> N/A</div>
								<div class="lasInfoImage">
									<app-shared-view *ngIf="this.historyObject.selectedPanorama"
													 [(selectedPanorama)]="this.historyObject.selectedPanorama"
													 [(sitePanoramicHotspots)]="this.historyObject.sitePanoramicHotspots"
													 [showCompass]="false"
													 [isOwner]="false" [(selectedMonument)]="this.historyObject.selectedMonument"
													 [(fileToShare)]="this.historyObject.fileToShare"
													 [site]="selectedSite" [(monumentView)]="this.historyObject.monumentView"
													 [(isMonumentOpen)]="this.historyObject.isMonumentOpen"
													 [panoramaHeight]="'30vh'" [guiEnabled]="false">
									</app-shared-view>
									<p *ngIf="!this.historyObject.selectedPanorama">
										No share information between has been shared with the visitors.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="guidePanelContainer files" *ngIf="isOwner()" [class.closed]="!panelsState.files">
					<div class="guideInner">
						<h3 class="text-center">Your Folders and Files</h3>
						<div class="folderContainer">
							<div class="folderBox">
								<div class="row">
									<div class="col-12">
										<button class="btn btn-outline-disabled" *ngIf="selectedFolder && selectedFolder.name != ownerId"
												(click)="backToPreviousFolder()">
											<fa-icon [icon]="['fas','arrow-left']"></fa-icon>
										</button>
										<button class="btn btn-outline-disabled pull-right"
												(click)="syncFolder(selectedFolder)">
											<fa-icon [icon]="['fas','sync-alt']"></fa-icon>
										</button>
									</div>
								</div>
								<div class="row" style="margin: 0;overflow: auto;height: 16vh;" *ngIf="selectedFolder">
									<div class="col-3 folder" (dblclick)="openFolder(folder)"
										 *ngFor="let folder of selectedFolder.folderDtos">
										<fa-icon [icon]="['fas','folder']"></fa-icon>
										<div class="folderName">{{folder.name}}</div>
									</div>
									<div class="col-3 folder" *ngFor="let file of selectedFolder.files" (dblclick)="openImage(file)">
										<fa-icon [icon]="['fas','image']"></fa-icon>
										<div class="folderName">{{file}}</div>
									</div>
								</div>
							</div>
							<div class="text-right m-t-10">
								<a href="javascript:void(0)" (click)="newFolder()" class="topNavLink buttonPrimary m-r-5">
									Create Folder
								</a>
								<a href="javascript:void(0)" (click)="openUpload()" class="topNavLink buttonPrimary">
									Upload File
								</a>
							</div>
							<div class="guideActions" *ngIf="step==2 && false">
								<div class="mt-3">View Action Buttons</div>
								<div class="leftBottomButtons">
									<div class="buttons" ngbDropdown>
										<span ngbDropdownToggle><fa-icon [icon]="['fas','layer-group']"></fa-icon> Change Period</span>
										<div ngbDropdownMenu class="selections">
											<button ngbDropdownItem (click)="changePeriod(true)">{{'TRANS_REMOTE.TRANS_NOW' | translate}}</button>
											<button ngbDropdownItem
													(click)="changePeriod()">{{globalDataService.getObjectTranslation(meeting.culturalRoute.site.siteTranslations, 'century')}}</button>
										</div>
									</div>
									<div class="buttons" ngbDropdown>
										<span ngbDropdownToggle><fa-icon [icon]="['fas','tags']"></fa-icon> Toggle Labels</span>
										<div ngbDropdownMenu class="selections">
											<button ngbDropdownItem>ON</button>
											<button ngbDropdownItem>OFF</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="meeting">
							<div class="waiting-conatiner" *ngIf="!meeting.started">
								{{waitingMessage}}
								<div class="" *ngIf="availableToStartTour">
									<button (click)="startTour()" class="pulseButton">Start meeting</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-container *ngIf="waitingForGuide">
	<div class="topNotificationBackdrop"></div>
	<div class="topNotificationMessage">
		<div class="topNotificationInner">
			<div class="topNotificationActualMessage">
				The guide have been dropped from the tour due to technical issues.
				If the guide is not connected in {{waitingForGuideMessage}} minutes the tour will canceled.
			</div>
		</div>
	</div>
</ng-container>
<div class="loaderContainer" *ngIf="flowLoading">
	<div class="loader-block" style="margin-top: 20%;">
		<svg id="loader2" viewBox="0 0 100 100">
			<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
		</svg>
	</div>
	<div>LOADING....</div>
</div>
<ng-template #loader>
	<div class="step text-center" style="position: absolute;left:39%">
		<div class="loader-block">
			<svg id="loader2" viewBox="0 0 100 100">
				<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
			</svg>
		</div>
		<div>LOADING....</div>
	</div>
</ng-template>
<ng-template #monumentBox let-monument="monument">
	<div class="siteBox">
		<div class="carouselContainer">
			<ngb-carousel *ngIf="monument.slides" [pauseOnHover]="true" [interval]="10000">
				<ng-template ngbSlide *ngFor="let image of monument.slides">
					<a (click)="openMonument(monument.id)">
						<div class="img-wrapper">
							<div class="img-background"></div>
							<div class="imgContainer" [style.background-image]="'url('+image+')'"></div>
						</div>
					</a>
				</ng-template>
			</ngb-carousel>
		</div>
		<div class="siteInfo">
			<a (click)="openMonument(monument)">
				<div><b>{{globalDataService.getObjectTranslation(monument.monumentTranslations, 'name')}}</b></div>
			</a>
			<div class="metaInfo">
				<div>{{globalDataService.getObjectTranslation(monument.monumentTranslations, 'shortDescription')}}</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #modalSave let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Upload a file</h4>
	</div>
	<div class="modal-body" style="height: 400px;">
		<p class="m-t-20">
			Maximum upload size: 2MB, File type: JPG, PNG, PDF
			<ngx-dropzone accept="image/jpeg,image/jpg,image/png,image/gif, application/pdf" maxFileSize="2000000" (change)="onSelectFile($event)">
				<ngx-dropzone-label>Σύρετε ή επιλέξτε αρχείο</ngx-dropzone-label>
				<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemoveFile(f)" ngProjectAs="ngx-dropzone-preview">
					<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
				</ngx-dropzone-preview>
			</ngx-dropzone>
		</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-success" (click)="saveFiles(); modal.dismiss()">Save</button>
	</div>
</ng-template>
<div id="popUpWindow-sites" class="popUpWindow">
	<ng-container *ngIf="selectedSite">
		<div class="siteBox">
			<div class="carouselContainer">
				<ngb-carousel *ngIf="selectedSite.slides" [pauseOnHover]="true" [interval]="10000">
					<ng-template ngbSlide *ngFor="let image of selectedSite.slides">
						<a>
							<div class="img-wrapper">
								<div class="img-background"></div>
								<div class="imgContainer" [style.background-image]="'url('+image+')'"></div>
							</div>
						</a>
					</ng-template>
				</ngb-carousel>
			</div>
			<div class="siteInfo">
				<a>
					<h4>{{globalDataService.getObjectTranslation(selectedSite.siteTranslations, 'name')}}</h4>
				</a>
				<div class="metaInfo">
					{{globalDataService.getObjectTranslation(selectedSite.siteTranslations, 'address')}}
					<ul style="padding: 0 5px;">
						<li><b>{{ 'TRANS_REMOTE.TRANS_VIRTUAL_TOURS' | translate }}:</b> {{selectedSite.panoramaImages.length}}</li>
						<li><b>{{ 'TRANS_REMOTE.TRANS_MONUMENT_NUMBERS' | translate }}:</b> {{selectedSite.totalMonuments}}</li>
						<li><b>Theaters:</b> 3</li>
						<li><b>Museums:</b> 1</li>
						<li><b>Conservatory:</b> 1</li>
					</ul>
					<div class="text-right">
						<button class="mainButton" (click)="changeStep(2, selectedSite)">Open Site</button>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>